// initial state
const state = {
  receiptRelatedStatus: {
    0: '未核销',
    1: '部分核销',
    2: '已核销'
  },
  collectionTypeText: {
    1: '销售收款',
    2: '预收款'
  },
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const receivedPayment = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/received-payment/received-payment.store.js